import parse from 'html-react-parser'
import React, { ReactNode, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import {
  HouseTranslatedContent,
  IHouseTranslatedContentProps,
} from './house-translated-content/HouseTranslatedContent'
import { Mixpanel } from '../../../../utils/Mixpanel'
import { Icon } from '../../../atoms'

const HouseDescriptionCard = ({ content }: { content: string }) => {
  const [show, setShow] = useState<boolean>(false)

  const getContent = () => {
    if (content) {
      let disableShow = false
      let index = content.indexOf('<br>')
      if (index === -1) {
        index = content.length
        disableShow = true
      }
      let resume = content.substring(0, index)
      const all = content.substring(index)
      index = resume.lastIndexOf('</p>')
      if (!show) {
        resume = resume.slice(0, index) + resume.slice(index)
      }

      return (
        <>
          {parse(resume)}
          {show && parse(all)}
          {!disableShow && (
            <div
              className={s.seeMore}
              onClick={() => {
                if (show) {
                  Mixpanel.track('House - See less')
                } else if (!show) {
                  Mixpanel.track('House - See more')
                }
                setShow(!show)
              }}
            >
              <span>
                {show ? (
                  <FormattedMessage
                    id='ui.HouseDescriptionCard.seeLess'
                    defaultMessage='Voir moins'
                  />
                ) : (
                  <FormattedMessage
                    id='ui.HouseDescriptionCard.seeMore'
                    defaultMessage='Voir plus'
                  />
                )}
              </span>
              <Icon name={show ? 'arrow-up' : 'arrow-down'} size={12} />
            </div>
          )}
        </>
      )
    }
    return parse(content)
  }

  return <div className={s.cardDescription}>{getContent()}</div>
}

export const HouseMain = ({
  title,
  content,
  className,
  translationParams,
}: {
  title: ReactNode
  content: string
  className?: string
  translationParams?: IHouseTranslatedContentProps
}) => {
  return (
    <div className={className}>
      {translationParams && <HouseTranslatedContent {...translationParams} />}
      <h2 className={s.titleContainer}>{title}</h2>
      <HouseDescriptionCard content={content} />
    </div>
  )
}

export default HouseMain
